<template lang="pug">
  SspLayout(area="tnt")
    template(slot="actions")
      LocationPicker(v-model="location" style="width: 400px;")
      div.pl15(v-if="location")
        button.btn.btn-default(v-visible-for="['ROLE_LOCATION_MANAGER']" @click="$refs.permissions.open('LOCATION', location.id)")
          i.fa.fa-users
          span.ml5 Permissions
        button.btn.btn-default(v-visible-for="['ROLE_LOCATION_MANAGER']" @click="$refs.locationInformationModal.open(location.id)")
          i.fa.fa-crosshairs
          span.ml5 Contact Information
    .row
      LocationDetails.col-sm-12(v-if="location" :location="location")

    .row.location-portal-navigation(v-if="location")
      .col-sm-2
        ul.navigation
          li.navigation-items.clickable
            router-link(:to="{name: 'byPackageType', params: {id: location.id}}") By Package Type
          li.navigation-items.clickable
            router-link(:to="{name: 'byProduct', params: {id: location.id}}") By Products
          li.navigation-items.clickable
            router-link(:to="{name: 'events', params: {id: location.id}}") Events
          li.navigation-items.clickable
            router-link(:to="{name: 'packageFlow', params: {id: location.id}}") Package Flow
          li.navigation-items.clickable
            router-link(:to="{name: 'recalled', params: {id: location.id}}") Recalled
          li.navigation-items.clickable
            router-link(:to="{name: 'returned', params: {id: location.id}}") Returned
          li.navigation-items.clickable
            router-link(:to="{name: 'soldConsumer', params: {id: location.id}}") Sold Consumer

      .col-sm-10(v-if="location")
        router-view

    Permissions(ref="permissions")
    LocationInformationModal(ref="locationInformationModal")
</template>

<script>
import LocationPicker from '@/components/ssp/LocationPicker'
import TrackNTrace from '@/service/apis/TrackNTrace'
import Permissions from '@/components/ssp/Permissions'
import LocationDetails from './components/LocationDetails'
import LocationInformationModal from './components/ContactInformationModal'

export default {
  data: () => ({
    activeTab: 0,
    location: null
  }),
  created() {
    if (this.locationId) {
      TrackNTrace.getLocation(this.locationId)
        .then((resp) => {
          this.location = resp.data.fixedLocation
        })
    }
  },
  watch: {
    location() {
      if (this.location) {
        this.$router.push({ name: 'byPackageType', params: { id: this.location.id } })
      } else {
        this.$router.push({ name: 'locationPortal' })
      }
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    LocationPicker,
    LocationDetails,
    Permissions,
    LocationInformationModal
  }
}
</script>

<style lang="scss">
.location-portal-navigation {
  .navigation {
    border-radius: 4px;
    background-color: #f5f5f5;
  }
  .router-link-active {
    background-color: #dddddd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/LocationPortal.vue